import { useContext } from 'react';
import { AccessManagement2NModalContext } from './index';

/**
 * Custom hook to consume AccessManagement2NModalContext
 * Provides convenient access to modal state and action creators
 * @throws {Error} If used outside AccessManagement2NModalProvider
 */
export const useAccessManagement2NModal = () => {
  const context = useContext(AccessManagement2NModalContext);

  if (!context) {
    throw new Error(
      'useAccessManagement2NModal must be used within AccessManagement2NModalProvider',
    );
  }

  return context;
};

